<template>
 <v-dialog v-model="show" persistent max-width="400px">
       <v-card>
        <v-toolbar
          color="orange lighten-1"
          dark
        >

          <v-toolbar-title   class="headline">Notifikationer</v-toolbar-title>
 <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>circle_notifications</v-icon>
          </v-btn>
        </v-toolbar>
<v-timeline
            align-top
            dense
          >
            <v-timeline-item
              v-for="action in newActions"
              :key="action.time"
              :color="action.color"
              small
            >
              <div>
                <div class="font-weight-normal">
                  <strong>{{ action.name }}</strong> {{ action.status }}
                </div>
                <div>{{ action.detail }} {{action.bindWord}} {{ locfun.getDate(action.time)  }}</div>
                <div></div>
              </div>
            </v-timeline-item>
          </v-timeline>
                      <v-btn dark color="blue darken-1" @click="show = false">
                Stäng
              </v-btn>
      </v-card>

 </v-dialog>
</template>
<script>
import fun from "./functions";
import { mapActions,mapGetters } from "vuex";
export default {
    name:"Notification",

  computed: {
    
    ...mapGetters('ehtmembers', ['member']),
    ...mapGetters('teachers', ['teacher']),
    ...mapGetters('cases', ['cases', 'casesnames']),
    show: {
      get () {
   if (this.value!=this.dialog) {
     if (this.As=="teacher") {
 this.oldLastOnline=this.teacher.oldLastOnline
 
//  (this.teacher)
} else if (this.As=="EHT") {
  //  (this.member)
    this.oldLastOnline=this.member.oldLastOnline
}
let updates = this.cases.filter(Case=> Case.steps[Case.steps.length-1].starttime >= this.oldLastOnline)
let feedback = this.cases.filter(Case=> Case.hasOwnProperty("feedbackTime"))
feedback = feedback.filter(Case=> Case.feedbackTime>=this.oldLastOnline)
let newActions= [];
let i=0;
updates.forEach(update => {
  let object= update.steps[update.steps.length-1]
  let newobject={detail: object.step, time: object.starttime, color:this.colors[i], status: "Ärende förändring",bindWord:"påbörjades" , name: update.name  }
  newActions.push(newobject)
  i++;
});
 i=0;
feedback.forEach(update => {
  let object= update
  let newobject={detail: object.feedback, time: object.feedbackTime, color:this.colors[i], status: "Återkoppling",bindWord:"skickades" , name: update.name  }
  newActions.push(newobject)
  i++;
});
this.newActions=newActions;
        }
//         this.dialog=this.value

        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },
  created(){
       this.locfun= new fun();

  },
    props:{
        As: String,
        value: Boolean
    },
data() {
    return {
      locfun:null,
      User: null,
      oldLastOnline:0,
      dialog:false,
      newActions:[],
      colors: ["green", "pink", "blue","red","orange","yellow","brown","purple","amber"]
    };
  },
  methods: {
   
    ...mapActions('teachers', ['saveteacher']),
    ...mapActions('ehtmembers', ['savemember']),
   
}
}
</script>
<style >

</style>